import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UsersService {
    /**
     * Update Bnames To User
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static updateBnamesToUserAdminUpdateBnamesPut(requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/update/bnames',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Bnames By User
     * @param limit Limit the number of results
     * @param offset Offset the results
     * @param searchTerm
     * @returns LimitOffsetResponse Successful Response
     * @throws ApiError
     */
    static getBnamesByUserUserBnamesGet(limit = 50, offset, searchTerm) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/bnames',
            query: {
                'limit': limit,
                'offset': offset,
                'search_term': searchTerm,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Bnames By User No Auth
     * @param userId
     * @param limit Limit the number of results
     * @param offset Offset the results
     * @param searchTerm
     * @returns LimitOffsetResponse Successful Response
     * @throws ApiError
     */
    static getBnamesByUserNoAuthUserBnamesNoAuthGet(userId, limit = 50, offset, searchTerm) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/bnames/no_auth',
            query: {
                'user_id': userId,
                'limit': limit,
                'offset': offset,
                'search_term': searchTerm,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Am Names
     * Get all distinct AM names for the user's chain
     * @returns string Successful Response
     * @throws ApiError
     */
    static getAmNamesAmNamesGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/am_names',
        });
    }
}
